import D2C_ProviderHosting from './Hosting'

class D2C_ProviderGCP extends D2C_ProviderHosting {
  static objectType = 'providerType'
  static active = true
  static order = 15
  static providerType = 'GCP'
  static providerTitle = 'Google Cloud Platform'
  static helpLink = 'https://docs.d2c.io/providers/cloud-providers/#google-cloud-platform'
  static fields = {
    ...D2C_ProviderHosting.fields,
    credentials: {
      default: null,
      path: 'auth.credentials',
      required: true,
      validate(value) {
        const credentialFields = [
          'type',
          'project_id',
          'private_key_id',
          'private_key',
          'client_email',
          'client_id',
          'auth_uri',
          'token_uri',
          'auth_provider_x509_cert_url',
          'client_x509_cert_url'
        ]
        if (!value) {
          return 'Credentials must be uploaded'
        }
        for (const field of credentialFields) {
          if (typeof value[field] !== 'string') {
            return 'Invalid credentials file'
          }
        }
        return null
      },
      creating: {},
    },
  }
}

export default D2C_ProviderGCP
